module.exports = __webpack_public_path__ + "img/24.5e52f8f7.png";